import { useState } from "react";
import PageIntro from "../Components/modern/PageIntro";
import { Container } from "../Components/modern/UI";
import { FaFacebookF, FaInstagram, FaLinkedinIn, FaWhatsapp, FaYoutube } from "react-icons/fa";

const contactDetails = {
  address: "68 and 69, 1st Main Rd, Vishwaneedam, Srigandhadakaval, Sunkadakatte, Bengaluru, Karnataka 560091, India",
  phones: ["+91 9380226919", "+91 8105935278"],
  email: "suryanirbhar.pvtltd@gmail.com",
  mapSrc: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3887.690496871931!2d77.50906527484177!3d12.991636987325535!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bae3d5c6d941e0b%3A0xc10104d9f1e3177b!2sSuryanirbhar%20Agritech%20Private%20Limited!5e0!3m2!1sen!2sus!4v1780040096398!5m2!1sen!2sus",
};

const socialLinks = [
  { label: "Instagram", href: "https://www.instagram.com/suryanirbhar_agritech_/", Icon: FaInstagram },
  { label: "LinkedIn", href: "https://www.linkedin.com/company/suryanirbhar-agritech/", Icon: FaLinkedinIn },
  { label: "YouTube", href: "https://youtube.com/@suryanirbhar_agritech?si=uNhjJx-LTAuU1Ows", Icon: FaYoutube },
  { label: "Facebook", href: "https://www.facebook.com/suryanirbhar.agritech/", Icon: FaFacebookF },
  { label: "WhatsApp", href: "https://wa.me/919380226919?text=Hello%20I%20want%20to%20know%20about%20your%20products", Icon: FaWhatsapp },
];

const productOptions = [
  "Single Wheel Weeder",
  "Electric Cono Weeder (Paddy Weeder)",
  "Poultry Raking Machine",
  "Trolley Brush Cutter",
  "Side pack Brush Cutter",
  "e-Trolley",
  "Paddy Thresher",
];

const faqItems = [
  {
    question: "How long does the battery last, and what is the recharge time?",
    answer: `Discharge: The battery lasts 3 to 4 hours on average (covering up to 1 acre), depending on soil conditions and attachments.

Charging: It takes about 2 hours to charge fully from 0% to 100%.`,
  },
  {
    question: "What is the warranty coverage for the machine and battery?",
    answer: "1-year standard warranty for the machine and 2-year warranty for the battery from the date of invoice (excluding the gearbox, which requires regular greasing).",
  },
  {
    question: "What kind of after-sales service and support is provided?",
    answer: "Most issues are resolved quickly via video call by indicators on the machine. For major issues, our team will visit your location or courier spare parts for a quick replacement.",
  },
  {
    question: "Can I get an on-field demonstration or visit the factory?",
    answer: "Yes, we shall coordinate and plan for a demonstration at your field or give you the nearest point where the machine is available on-field for a visit! Further, You can visit our unit at Sunkadakatte, Magadi Road (Monday to Saturday, 10:00 AM to 6:00 PM). Please call 9380226919 before dropping by.",
  },
  {
    question: "Who can operate these machines?",
    answer: "The machines are lightweight and user-friendly; hence, women labourers can easily operate them with basic guidance and practice",
  },
  {
    question: "How to place an order? How long will it take to deliver to us",
    answer: `We accept orders through our website, or call us on 9380226919 to place an order.

We typically take 3-4 days to dispatch. We send via VRL or similar logistics on toPay basis`,
  },
];

const initialFormData = {
  name: "",
  email: "",
  phone: "",
  product: "",
  subject: "",
  message: "",
};

const fieldClass = "sn-w-full sn-rounded sn-border sn-border-line sn-bg-cream sn-px-4 sn-py-3 sn-text-sm sn-text-ink sn-outline-none sn-transition placeholder:sn-text-muted/70 focus:sn-border-leaf focus:sn-bg-white focus:sn-ring-2 focus:sn-ring-leaf/15";

export default function Contact() {
  const [formData, setFormData] = useState(initialFormData);
  const handleChange = (event) => {
    setFormData((current) => ({ ...current, [event.target.name]: event.target.value }));
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    const form = event.currentTarget;
    if (!form.checkValidity()) {
      form.reportValidity();
      return;
    }

    const message = [
      "Hello Suryanirbhar Agritech,",
      "",
      "I would like to make an enquiry.",
      "",
      `Name: ${formData.name}`,
      `Email: ${formData.email}`,
      `Phone: ${formData.phone}`,
      `Product: ${formData.product}`,
      `Subject: ${formData.subject}`,
      `Message: ${formData.message}`,
    ].join("\n");

    const whatsappUrl = `https://wa.me/919380226919?text=${encodeURIComponent(message)}`;
    window.open(whatsappUrl, "_blank", "noopener,noreferrer");
  };

  return (
    <>
      <PageIntro eyebrow="Contact" title={<>Reach the Suryanirbhar team.</>} />

      <section aria-labelledby="sn-contact-main" className="sn-py-12 md:sn-py-16">
        <Container>
          <div className="sn-grid sn-items-stretch sn-gap-8 lg:sn-grid-cols-[0.9fr_1.1fr]">
            <div className="sn-flex sn-h-full sn-flex-col sn-rounded-card sn-border sn-border-line sn-bg-white sn-p-6 sn-shadow-soft md:sn-p-8">
              <h2 id="sn-contact-main" className="sn-font-display sn-text-3xl sn-leading-tight sn-text-forest">Company Details</h2>
              <div className="sn-mt-7 sn-space-y-6">
                <div>
                  <h3 className="sn-text-[11px] sn-font-bold sn-uppercase sn-tracking-[0.18em] sn-text-leaf">Address</h3>
                  <p className="sn-mt-2 sn-text-sm sn-leading-relaxed sn-text-muted">{contactDetails.address}</p>
                </div>
                <div>
                  <h3 className="sn-text-[11px] sn-font-bold sn-uppercase sn-tracking-[0.18em] sn-text-leaf">Phone</h3>
                  <div className="sn-mt-2 sn-space-y-1">
                    {contactDetails.phones.map((phone) => (
                      <a key={phone} href={`tel:${phone.replace(/[^0-9+]/g, "")}`} className="sn-block sn-text-sm sn-font-semibold sn-text-forest hover:sn-text-leaf">{phone}</a>
                    ))}
                  </div>
                </div>
                <div>
                  <h3 className="sn-text-[11px] sn-font-bold sn-uppercase sn-tracking-[0.18em] sn-text-leaf">Email</h3>
                  <p className="sn-mt-2 sn-text-sm sn-font-semibold sn-text-forest">{contactDetails.email}</p>
                </div>
                <div>
                  <h3 className="sn-text-[11px] sn-font-bold sn-uppercase sn-tracking-[0.18em] sn-text-leaf">Social links</h3>
                  <div className="sn-mt-3 sn-flex sn-flex-wrap sn-gap-3">
                    {socialLinks.map(({ label, href, Icon }) => (
                      <a key={label} href={href} target="_blank" rel="noopener noreferrer" className="sn-inline-flex sn-items-center sn-gap-2 sn-rounded-full sn-border sn-border-forest/20 sn-px-4 sn-py-2 sn-text-sm sn-font-semibold sn-text-forest hover:sn-bg-sage">
                        <Icon aria-hidden="true" className="sn-h-4 sn-w-4" />
                        {label}
                      </a>
                    ))}
                  </div>
                </div>
                <div className="sn-overflow-hidden sn-rounded-card sn-border sn-border-line sn-bg-cream">
                  <iframe
                    title="Suryanirbhar Agritech Private Limited location on Google Maps"
                    src={contactDetails.mapSrc}
                    className="sn-block sn-h-[220px] sn-w-full"
                    style={{ border: 0 }}
                    allowFullScreen=""
                    loading="lazy"
                    referrerPolicy="no-referrer-when-downgrade"
                  />
                </div>
              </div>
            </div>

            <div className="sn-flex sn-h-full sn-flex-col sn-rounded-card sn-border sn-border-line sn-bg-white sn-p-6 sn-shadow-soft md:sn-p-8">
              <h2 className="sn-font-display sn-text-3xl sn-leading-tight sn-text-forest">Contact Form</h2>
              <form className="sn-mt-7 sn-flex sn-flex-1 sn-flex-col sn-space-y-5" onSubmit={handleSubmit} noValidate={false}>
                <div className="sn-grid sn-gap-5 md:sn-grid-cols-2">
                  <label className="sn-block sn-text-sm sn-font-semibold sn-text-forest">
                    Name *
                    <input className={`${fieldClass} sn-mt-2`} type="text" name="name" value={formData.name} onChange={handleChange} autoComplete="name" placeholder="Your name" required />
                  </label>
                  <label className="sn-block sn-text-sm sn-font-semibold sn-text-forest">
                    Email *
                    <input className={`${fieldClass} sn-mt-2`} type="email" name="email" value={formData.email} onChange={handleChange} autoComplete="email" placeholder="you@example.com" required />
                  </label>
                </div>
                <label className="sn-block sn-text-sm sn-font-semibold sn-text-forest">
                  Phone number *
                  <input className={`${fieldClass} sn-mt-2`} type="tel" name="phone" value={formData.phone} onChange={handleChange} autoComplete="tel" placeholder="10-digit mobile number" pattern="[0-9+\-\s]{10,}" required />
                </label>
                <label className="sn-block sn-text-sm sn-font-semibold sn-text-forest">
                  Product *
                  <select className={`${fieldClass} sn-mt-2`} name="product" value={formData.product} onChange={handleChange} required>
                    <option value="">Select a product</option>
                    {productOptions.map((product) => <option key={product} value={product}>{product}</option>)}
                  </select>
                </label>
                <label className="sn-block sn-text-sm sn-font-semibold sn-text-forest">
                  Subject *
                  <input className={`${fieldClass} sn-mt-2`} type="text" name="subject" value={formData.subject} onChange={handleChange} placeholder="How can we help?" required />
                </label>
                <label className="sn-block sn-flex-1 sn-text-sm sn-font-semibold sn-text-forest">
                  Message *
                  <textarea className={`${fieldClass} sn-mt-2 sn-min-h-[150px] sn-resize-y`} name="message" value={formData.message} onChange={handleChange} placeholder="Tell us what you need." required />
                </label>
                <button type="submit" className="sn-inline-flex sn-min-h-[48px] sn-w-full sn-items-center sn-justify-center sn-rounded sn-bg-forest sn-px-6 sn-py-3 sn-text-sm sn-font-semibold sn-text-white sn-transition hover:sn-bg-leaf md:sn-w-auto">
                  Enquire on WhatsApp
                </button>
              </form>
            </div>
          </div>
        </Container>
      </section>

      {/* Temporarily hidden per client review; FAQ content will be revised. */}
      {false && <div>{faqItems.length}</div>}
    </>
  );
}
